import {Utils} from "../../utils";
import {HomeItemRenderer} from "./home-item-renderer"
import { CalendarResponseEntryDto } from "../../dtos/calendar-response-entry-dto";
import { Utility } from "../../libs/utility";
import * as moment from 'moment';

export class ScheduleRenderer extends HomeItemRenderer{

	private lastPlayType = "Zum letzten Mal";

	constructor(container:HTMLElement, private plays: CalendarResponseEntryDto[],isForMobile:boolean){
		super(container);
		this.isForMobile = isForMobile;
	}

	public render(){
		var containerHtml =  document.createElement("div");
		containerHtml.classList.add("p_home_schedule");

		var headlineHtml = document.createElement("div");
		headlineHtml.classList.add("_headline");
		headlineHtml.classList.add("titleMedium");
		headlineHtml.innerHTML = "Nächste Aufführungen";

		var detailsHtml = document.createElement("div");
		detailsHtml.classList.add('_details');

		let html = "";

		let day = -1;
		let month = -1;

		for(const play of this.plays) {
			// TODO: change event rendering when it's clear under which conditions from fields "ticketsAvailableFrom" and "privateEvent" what should displayed
			const begin = moment(play.begin).toDate();

			if(day != begin.getDate() || month != begin.getMonth()) {
				html += `
<div class='_dayHeader'>
	<span class='_day dateLarge'>${Utility.padNumber2(begin.getDate())}</span>
	<span class='_weekday weekdayMedium'>${Utility.weekdays[(begin.getDay() + 6) % 7]}</span>
	<span class='_month weekdayMedium'>${month != begin.getMonth() ? Utility.months[begin.getMonth()] : ""}</span>
</div>`;

				day = begin.getDate();
				month = begin.getMonth();
			}
			const now = new Date();
			let ticketUrl = "";
			let greenBadges = "";
			const nintyMinutes = new Date(now.getTime() + (90 * 60 * 1000));


			if(play.price == null) {
				play.price = ""
			}

			if(play.dispoComment == null) {
				play.dispoComment = ""
			}

			if(play.type == null) {
				play.type = ""
			}

			if(play.overTitle == null) {
				play.overTitle = ""
			}


			if(play.cancelled === "1") {
				ticketUrl = "<a title='Abgesagt' class='icon-ticket _soldOut'></a>";
				greenBadges = '<span class="_green-badges"><span class="_text">abgesagt</span></span>';
			} else {
				if(play.type === this.lastPlayType) {
					greenBadges = '<span class="_green-badges"><span class="_text">Zum letzten Mal</span></span>';
				}

				if (play.price.toLowerCase().indexOf("eintritt frei") !== -1) {
					ticketUrl = "<a title='Freier Eintritt' class='icon-ticket _soldOut'></a>";
				} else if (play.price.toLowerCase().indexOf("geschlossene vorstellung") !== -1) {
					ticketUrl = "<a title='Geschlossene Vorstellung' class='icon-ticket _soldOut'></a>";
				} else if(play.ticketLink && begin >= nintyMinutes){
					ticketUrl = `<a class='_ticket icon-ticket' target='_blank' aria-label='Tickets kaufen' title='Tickets kaufen' href='${play.ticketLink}'></a>`
				}else{
					ticketUrl = "<a title='Wenige Restkarten an der Abendkasse' class='icon-ticket _soldOut'></a>"
				}
			}


			let timeString;
			let end = null;
			if(play.end != null) {
				end = moment(play.end).toDate();
				timeString = `${Utility.getTime(begin)} - ${Utility.getTime(end)}`;
			}
			else {
				timeString = Utility.getTime(begin);
			}


			let icalUrl = "";
			if ((end == null && begin >= now) || (end != null && end >= now)) {
				let icalGet = "?date=";
				let tempDate = `${Utility.padNumber2(begin.getMonth() + 1)}/${Utility.padNumber2(begin.getDate())}/${begin.getFullYear()}`;
				icalGet += encodeURIComponent(tempDate);
				icalGet += `&sh=${Utility.padNumber2(begin.getHours())}&sm=${Utility.padNumber2(begin.getMinutes())}`;
				if (end != null) {
					icalGet += `&eh=${Utility.padNumber2(end.getHours())}&em=${Utility.padNumber2(end.getMinutes())}`;
				}
				icalGet += `&subject=${encodeURIComponent(play.name)}`;

				icalUrl = `<a title='Kalenderdatei laden' aria-label='Kalenderdatei laden' class='_ical icon-calendar-mini' onClick='THOR.Main.logEvent({"produktionsId" : ${play.ProduktionsId}, "vorstellungsId" : ${play.id}, "type": "INTEREST"}, "30", function(){window.location.href="/ical/date${icalGet}"});' target="_blank"></a>`
			}

			var seperator1=""
			if(play['place'] && play['begin']){
				seperator1 = "<span class='seperator'></span>";
			}
			var seperator2=""
			if(play['begin'] && play['dispoComment']){
				seperator2 = "<span class='seperator'></span>";
			}

			var typePhone ="";

			html += `
<div class='_detail'>
	<div class='_links'>
		${greenBadges}${icalUrl}${ticketUrl}
	</div>
	<div class='_placeAndTime calendarMiniBold'><span class='_place'>${play.place}</span>${seperator1} <span class='_time'>${timeString}</span>${seperator2} <span>${play.dispoComment}</span></div>
	<div class='_price calendarMini'>${play.price}</div>

	<div class='calendarMiniBold _line3'>`;

	switch (play['type']) {
		case "Vorstellung":
		case "Voraufführung":
		case "Voraufführung öffentlich":
		case "Einzelvorstellung":
		case "Abstecher Gastspiel":
		case "Vermietung":
		case "Vermietung (Schauspielhaus Graz)":
		case "Pressekonferenz":
		case "Lesung":
		case "Ausstellung":
		html += `<span class='_overtitle'>${play.overTitle}</span>`;
		break;
		case "Premiere":
		case "Zu Gast":
		case "Gastspiel":
			if(play.type != null) {
				html += `<span class='_typeMobile'>${play.type}</span>`;
			}

			if ((play['overTitle'])) {
				html += `<span class='seperator'></span>
				<span class='_overtitle'>${play.overTitle}</span>`;
			}
		break;
		case this.lastPlayType:
			if ((play['overTitle'])) {
				html += `<span class='_overtitle'>${play.overTitle}</span>`;
			}
			break;
		case "Wiederaufnahme":
			if(play.type != null) {
				html += `<span class='_type _warning'>${play.type}</span>`;
			}
			if ((play['overTitle'])) {
				html += `<span class='_overtitle'> | ${play.overTitle}</span>`;
			}
		break;
		default:
			if(play.type != null) {
				html += `<span class='_type _warning'>${play.type}</span>`;
			}

			if ((play['overTitle'])) {
				html += `<span class='_overtitle'> | ${play.overTitle}</span>`;
			}
		break;
	}
	html += `</div>`;

	html += `
		<div class='_name headline4'><a href='/play-detail/${play.link}'>${play.name}</a></div>`

		if(play.subtitle !== null) {
			html += `<div class='_subtitle calendarMini'>${play.subtitle}</div>`
		}
		if(play.addition1 !== null) {
			html += `<div class='_addition1 calendarMini'>${play.addition1}</div>`
		}
		if(play.addition2 !== null) {
			html += `<div class='_addition2 calendarMiniBold'>${play.addition2}</div>`
		}

		html += `<span class="clear-all"></span>`
		html += `</div>`

		}

		detailsHtml.innerHTML = html;

		var fullScheduleHtml = document.createElement("div");
		fullScheduleHtml.classList.add("_fullScheduleLink");
		fullScheduleHtml.innerHTML = "<a class='link2' href='/spielplan/#Alle'>Alle Termine</a>";

		containerHtml.appendChild(headlineHtml);
		containerHtml.appendChild(detailsHtml);
		containerHtml.appendChild(fullScheduleHtml);

		this.renderContainer(this.isForMobile).appendChild(containerHtml);
	}
}
